import React from "react";
import { FIRST_INDEX, SECOND_INDEX } from "./constants";

/**
 * InTransitDeadlineCell Component
 * Displays in-transit deadline date and time separated
 * @param {Object} row - The row data object
 */
const InTransitDeadlineCell = ({ row }) => {
  return (
    <span className="text-sm font-normal">
      {row.original.InTransitDeadline.split("T")[FIRST_INDEX]}
      <br />
      {row.original.InTransitDeadline.split("T")[SECOND_INDEX]}
    </span>
  );
};

export default InTransitDeadlineCell;
